import './marker.css'
// import styled from 'styled-components';

// const Wrapper = styled.div`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   width: 18px;
//   height: 18px;
//   background-color: #000;
//   border: 2px solid #fff;
//   border-radius: 100%;
//   user-select: none;
//   transform: translate(-50%, -50%);
//   cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
//   &:hover {
//     z-index: 1;
//   }
// `;

const Marker:React.FC<MarkerProps> = ({ lat, lng }) => (
  lat && lng
   ?
    // <Wrapper
    //   alt={text}
    //   onClick={onClick}
    // />
    <>
      <div className='pin' />
      <div className='pulse' />
    </>
    :
    <></>
);

interface MarkerProps {
  lat: number
  lng: number
};

export default Marker;